import { apiClient } from './client';

export interface Plan {
  code: string;
  name: string;
  currency: string;
  monthlyPrice: number;
  agentLimit: number | null;
  features: unknown;
  public: boolean;
}

export async function listPlans(): Promise<Plan[]> {
  const { data } = await apiClient.get<Plan[]>('/plans');
  return data;
}
